import { createFileRoute } from '@tanstack/react-router'

import { fontLanguageOverride } from '@/utils/font-language-override'

export const Route = createFileRoute('/$country/$language')({
  head: ({ params }) => {
    const fontLang = fontLanguageOverride(params.country, params.language)
    return {
      links: [
        {
          href: `https://ikea.marat.qd.je/global/assets/fonts/${fontLang}/fonts.css`,
          rel: 'stylesheet',
        },
      ],
    }
  },
})
